import {
  start as publicStart,
  verifyDuringAuthentication as publicVerifyDuringAuthentication,
} from './iam-verification-v1-start-response-verification.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const start: MaybeContext<
  BuildRESTFunction<typeof publicStart> & typeof publicStart
> = /*#__PURE__*/ createRESTModule(publicStart);
export const verifyDuringAuthentication: MaybeContext<
  BuildRESTFunction<typeof publicVerifyDuringAuthentication> &
    typeof publicVerifyDuringAuthentication
> = /*#__PURE__*/ createRESTModule(publicVerifyDuringAuthentication);

export {
  Target,
  StateType,
  PrivacyStatus,
  EmailTag,
  PhoneTag,
  AddressTag,
  StatusName,
  Reason,
  FactorType,
  Status,
  FactorStatus,
  MfaReason,
} from './iam-verification-v1-start-response-verification.universal.js';
export {
  StartResponse,
  StartRequest,
  VerifyRequest,
  VerifyResponse,
  VerifyDuringAuthenticationRequest,
  StateMachineResponse,
  StateMachineResponseStateDataOneOf,
  Identity,
  Connection,
  ConnectionTypeOneOf,
  IdpConnection,
  AuthenticatorConnection,
  IdentityProfile,
  CustomField,
  V1CustomValue,
  V1CustomValueValueOneOf,
  V1ListValue,
  V1MapValue,
  SecondaryEmail,
  Phone,
  AddressWrapper,
  Address,
  Metadata,
  Email,
  StatusV2,
  Factor,
  CustomValue,
  CustomValueValueOneOf,
  ListValue,
  MapValue,
  RequireMfaData,
  V1Factor,
  MfaChallengeData,
  VerificationChallenge,
  VerificationChallengeFactorChallengeDataOneOf,
  PushChallengeData,
  WebAuthnChallengeData,
  StartOptions,
  VerifyDuringAuthenticationOptions,
} from './iam-verification-v1-start-response-verification.universal.js';
export {
  TargetWithLiterals,
  StateTypeWithLiterals,
  PrivacyStatusWithLiterals,
  EmailTagWithLiterals,
  PhoneTagWithLiterals,
  AddressTagWithLiterals,
  StatusNameWithLiterals,
  ReasonWithLiterals,
  FactorTypeWithLiterals,
  StatusWithLiterals,
  FactorStatusWithLiterals,
  MfaReasonWithLiterals,
  VerifyDuringAuthenticationApplicationErrors,
} from './iam-verification-v1-start-response-verification.universal.js';
